export default "__VITE_ASSET__c0f1f67f__"